import * as S from "./cart-item.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import type { CartItemProps } from "./types";

export const CartItem = ({
    id,
    name,
    image,
    price,
    quantity,
    onIncrease,
    onDecrease,
    onRemove,
}: CartItemProps) => {
    return (
        <S.Item key={id}>
            <S.Left>
                <S.Image src={image} alt={name} />
                <S.Info>
                    <S.Title title={name}>{name}</S.Title>
                    <S.Price>{price}</S.Price>
                </S.Info>
            </S.Left>

            <S.Actions>
                <S.ActionButton onClick={onDecrease} disabled={quantity <= 1} aria-label="Diminuir quantidade do item">
                    <FontAwesomeIcon icon={faMinus} />
                </S.ActionButton>

                <S.Quantity value={quantity} readOnly />

                <S.ActionButton onClick={onIncrease} aria-label="Aumentar quantidade do item">
                    <FontAwesomeIcon icon={faPlus} />
                </S.ActionButton>

                <S.RemoveButton onClick={onRemove} aria-label="Remover item do carrinho">
                    <FontAwesomeIcon icon={faTrash} />
                </S.RemoveButton>
            </S.Actions>
        </S.Item>
    );
};
